/*
 * GLOBAL ROOT (DO NOT CHANGE)
 */
$.root_ = $('body');
/*
 * APP CONFIGURATION (HTML/AJAX/PHP Versions ONLY)
 * Description: Enable / disable certain theme features here
 * GLOBAL: Your left nav in your app will no longer fire ajax calls, set
 * it to false for HTML version
 */
$.navAsAjax = false;
/*
 * GLOBAL: Sound Config (define sound path, enable or disable all sounds)
 */
$.sound_path = "/sound/";
$.sound_on   = false;
/*
 * SAVE INSTANCE REFERENCE (DO NOT CHANGE)
 * Save a reference to the global object (window in the browser)
 */
var root                      = this,
    /*
     * Impacts the responce rate of some of the responsive elements (lower
     * value affects CPU but improves speed)
     */
    throttle_delay            = 350,
    /*
     * The rate at which the menu expands revealing child elements on click
     */
    menu_speed                = 235,
    /*
     * Collapse current menu item as other menu items are expanded
     * Careful when using this option, if you have a long menu it will
     * keep expanding and may distrupt the user experience This is best
     * used with fixed-menu class
     */
    menu_accordion            = true,
    /*
     * Turn on JarvisWidget functionality
     * Global JarvisWidget Settings
     * For a greater control of the widgets, please check app.js file
     * found within COMMON_ASSETS/UNMINIFIED_JS folder and see from line 1355
     * dependency: js/jarviswidget/jarvis.widget.min.js
     */
    enableJarvisWidgets       = true,
    /*
     * Warning: Enabling mobile widgets could potentially crash your webApp
     * if you have too many widgets running at once
     * (must have enableJarvisWidgets = true)
     */
    enableMobileWidgets       = false,
    /*
     * Turn on fast click for mobile devices
     * Enable this to activate fastclick plugin
     * dependency: js/plugin/fastclick/fastclick.js
     */
    fastClick                 = false,
    /*
     * Use localstorage to save widget settings
     * turn this off if you prefer to use the onSave hook to save
     * these settings to your datatabse instead
     */
    localStorageJarvisWidgets = true,
    /*
     * Turn off sortable feature for JarvisWidgets
     */
    sortableJarvisWidgets     = true;
/*
 * END APP.CONFIG
 */

/*! SmartAdmin - v1.5 - 2014-10-16 */ function runAllForms() {
    $.fn.slider && $(".slider").slider(),
        $.fn.select2 &&
            $("select.select2").each(function () {
                var a = $(this),
                    b = a.attr("data-select-width") || "100%";
                a.select2({ allowClear: !0, width: b }), (a = null);
            }),
        $.fn.mask &&
            $("[data-mask]").each(function () {
                var a = $(this),
                    b = a.attr("data-mask") || "error...",
                    c = a.attr("data-mask-placeholder") || "X";
                a.mask(b, { placeholder: c }), (a = null);
            }),
        $.fn.autocomplete &&
            $("[data-autocomplete]").each(function () {
                var a = $(this),
                    b = a.data("autocomplete") || ["The", "Quick", "Brown", "Fox", "Jumps", "Over", "Three", "Lazy", "Dogs"];
                a.autocomplete({ source: b }), (a = null);
            }),
        $.fn.datepicker &&
            $(".datepicker").each(function () {
                var a = $(this),
                    b = a.attr("data-dateformat") || "dd.mm.yy";
                a.datepicker({ dateFormat: b, prevText: '<i class="fa fa-chevron-left"></i>', nextText: '<i class="fa fa-chevron-right"></i>', minDate: "+1d" }), (a = null);
            }),
        $("button[data-loading-text]").on("click", function () {
            var a = $(this);
            a.button("loading"),
                setTimeout(function () {
                    a.button("reset"), (a = null);
                }, 3e3);
        });
}

function checkURL() {
    var a = location.href.split("#").splice(1).join("#");
    if (!a)
        try {
            var b = window.document.URL;
            b && b.indexOf("#", 0) > 0 && b.indexOf("#", 0) < b.length + 1 && (a = b.substring(b.indexOf("#", 0) + 1));
        } catch (c) {}
    if (((container = $("#elements-content")), a)) {
        $("nav li.active").removeClass("active"), $('nav li:has(a[href="' + a + '"])').addClass("active");
        var d = $('nav a[href="' + a + '"]').attr("title");
        (document.title = d || document.title), debugState && root.console.log("Page title: %c " + document.title, debugStyle_green), loadURL(a + location.search, container);
    } else {
        var e = $('nav > ul > li:first-child > a[href!="#"]');
        (window.location.hash = e.attr("href")), (e = null);
    }
}
function loadURL(a, b) {
    debugState && root.root.console.log("Loading URL: %c" + a, debugStyle),
        $.ajax({
            type: "GET",
            url: a,
            dataType: "html",
            cache: !0,
            beforeSend: function () {
                if ($.navAsAjax && $(".google_maps")[0] && b[0] == $("#elements-content")[0]) {
                    var a = $(".google_maps"),
                        c = 0;
                    a.each(function () {
                        c++;
                        var b = document.getElementById(this.id);
                        c == a.length + 1 || (b && b.parentNode.removeChild(b), debugState && root.console.log("Destroying maps.........%c" + this.id, debugStyle_warning));
                    }),
                        debugState && root.console.log("\u2714 Google map instances nuked!!!");
                }
                if ($.navAsAjax && $(".dataTables_wrapper")[0] && b[0] == $("#elements-content")[0]) {
                    var d = $.fn.dataTable.fnTables(!0);
                    $(d).each(function () {
                        0 != $(this).find(".details-control").length ? ($(this).find("*").addBack().off().remove(), $(this).dataTable().fnDestroy()) : $(this).dataTable().fnDestroy();
                    }),
                        debugState && root.console.log("\u2714 Datatable instances nuked!!!");
                }
                if ($.navAsAjax && $.intervalArr.length > 0 && b[0] == $("#elements-content")[0] && enableJarvisWidgets) {
                    for (; $.intervalArr.length > 0; ) clearInterval($.intervalArr.pop());
                    debugState && root.console.log("\u2714 All JarvisWidget intervals cleared");
                }
                if (
                    ($.navAsAjax && b[0] == $("#elements-content")[0] && enableJarvisWidgets && $("#widget-grid")[0] && ($("#widget-grid").jarvisWidgets("destroy"), debugState && root.console.log("\u2714 JarvisWidgets destroyed")),
                    $.navAsAjax && b[0] == $("#elements-content")[0])
                ) {
                    if ("function" == typeof pagedestroy)
                        try {
                            pagedestroy(), debugState && root.console.log("\u2714 Pagedestroy()");
                        } catch (e) {
                            (pagedestroy = void 0), debugState && root.console.log("! Pagedestroy() Catch Error");
                        }
                    $.fn.sparkline && $("#elements-content .sparkline")[0] && ($("#elements-content .sparkline").sparkline("destroy"), debugState && root.console.log("\u2714 Sparkline Charts destroyed!")),
                        $.fn.easyPieChart && $("#elements-content .easy-pie-chart")[0] && ($("#elements-content .easy-pie-chart").easyPieChart("destroy"), debugState && root.console.log("\u2714 EasyPieChart Charts destroyed!")),
                        $.fn.select2 && $("#elements-content select.select2")[0] && ($("#elements-content select.select2").select2("destroy"), debugState && root.console.log("\u2714 Select2 destroyed!")),
                        $.fn.mask && $("#elements-content [data-mask]")[0] && ($("#elements-content [data-mask]").unmask(), debugState && root.console.log("\u2714 Input Mask destroyed!")),
                        $.fn.datepicker && $("#elements-content .datepicker")[0] && ($("#elements-content .datepicker").off(), $("#elements-content .datepicker").remove(), debugState && root.console.log("\u2714 Datepicker destroyed!")),
                        $.fn.slider && $("#elements-content .slider")[0] && ($("#elements-content .slider").off(), $("#elements-content .slider").remove(), debugState && root.console.log("\u2714 Bootstrap Slider destroyed!"));
                }
                (pagefunction = null),
                    b.removeData().html(""),
                    b.html('<h1 class="ajax-loading-animation"><i class="fa fa-cog fa-spin"></i> Loading...</h1>'),
                    b[0] == $("#elements-content")[0] &&
                        ($("body")
                            .find("> *")
                            .filter(":not(" + ignore_key_elms + ")")
                            .empty()
                            .remove(),
                        drawBreadCrumb(),
                        $("html").animate({ scrollTop: 0 }, "fast"));
            },
            success: function (a) {
                b.css({ opacity: "0.0" }).html(a).delay(50).animate({ opacity: "1.0" }, 300), (a = null), (b = null);
            },
            error: function (c, d, e) {
                b.html(
                    '<h4 class="ajax-loading-error"><i class="fa fa-warning txt-color-orangeDark"></i> Error requesting <span class="txt-color-red">' +
                        a +
                        "</span>: " +
                        c.status +
                        ' <span style="text-transform: capitalize;">' +
                        e +
                        "</span></h4>"
                );
            },
            async: !0,
        });
}
function drawBreadCrumb(a) {
    var b = $("nav li.active > a"),
        c = b.length;
    bread_crumb.empty(),
        bread_crumb.append($("<li>Home</li>")),
        b.each(function () {
            bread_crumb.append($("<li></li>").html($.trim($(this).clone().children(".badge").remove().end().text()))), --c || (document.title = bread_crumb.find("li:last-child").text());
        }),
        void 0 != a &&
            $.each(a, function (a, b) {
                bread_crumb.append($("<li></li>").html(b)), (document.title = bread_crumb.find("li:last-child").text());
            });
}
$.intervalArr = [];

var ie = (function () {
    for (var a, b = 3, c = document.createElement("div"), d = c.getElementsByTagName("i"); (c.innerHTML = "<!--[if gt IE " + ++b + "]><i></i><![endif]-->"), d[0]; );
    return b > 4 ? b : a;
})();
if (
    ($.fn.extend({
        jarvismenu: function (a) {
            var b = { accordion: "true", speed: 200, closedSign: "[+]", openedSign: "[-]" },
                c = $.extend(b, a),
                d = $(this);
            d.find("li").each(function () {
                0 !== $(this).find("ul").size() &&
                    ($(this)
                        .find("a:first")
                        .append("<b class='collapse-sign'>" + c.closedSign + "</b>"),
                    "#" == $(this).find("a:first").attr("href") &&
                        $(this)
                            .find("a:first")
                            .click(function () {
                                return !1;
                            }));
            }),
                d.find("li.active").each(function () {
                    $(this).parents("ul").slideDown(c.speed), $(this).parents("ul").parent("li").find("b:first").html(c.openedSign), $(this).parents("ul").parent("li").addClass("open");
                }),
                d.find("li a").click(function () {
                    0 !== $(this).parent().find("ul").size() &&
                        (c.accordion &&
                            ($(this).parent().find("ul").is(":visible") ||
                                ((parents = $(this).parent().parents("ul")),
                                (visible = d.find("ul:visible")),
                                visible.each(function (a) {
                                    var b = !0;
                                    parents.each(function (c) {
                                        return parents[c] == visible[a] ? ((b = !1), !1) : void 0;
                                    }),
                                        b &&
                                            $(this).parent().find("ul") != visible[a] &&
                                            $(visible[a]).slideUp(c.speed, function () {
                                                $(this).parent("li").find("b:first").html(c.closedSign), $(this).parent("li").removeClass("open");
                                            });
                                }))),
                        $(this).parent().find("ul:first").is(":visible") && !$(this).parent().find("ul:first").hasClass("active")
                            ? $(this)
                                  .parent()
                                  .find("ul:first")
                                  .slideUp(c.speed, function () {
                                      $(this).parent("li").removeClass("open"), $(this).parent("li").find("b:first").delay(c.speed).html(c.closedSign);
                                  })
                            : $(this)
                                  .parent()
                                  .find("ul:first")
                                  .slideDown(c.speed, function () {
                                      $(this).parent("li").addClass("open"), $(this).parent("li").find("b:first").delay(c.speed).html(c.openedSign);
                                  }));
                });
        },
    }),
    (jQuery.fn.doesExist = function () {
        return jQuery(this).length > 0;
    }),
    $.navAsAjax || $(".google_maps"))
) {
    var gMapsLoaded = !1;
    (window.gMapsCallback = function () {
        (gMapsLoaded = !0), $(window).trigger("gMapsLoaded");
    }),
        (window.loadGoogleMaps = function () {
            if (gMapsLoaded) return window.gMapsCallback();
            var a = document.createElement("script");
            a.setAttribute("type", "text/javascript"), a.setAttribute("src", "http://maps.google.com/maps/api/js?sensor=false&callback=gMapsCallback"), (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(a);
        });
}
$.navAsAjax &&
    ($("nav").length && checkURL(),
    $('nav a[href!="#"]').on("click", '', function (a) {
        a.preventDefault();
        var b = $(a.currentTarget);
        b.parent().hasClass("active") ||
            b.attr("target") ||
            ($.root_.hasClass("mobile-view-activated")
                ? ($.root_.removeClass("hidden-menu"),
                  $("html").removeClass("hidden-menu-mobile-lock"),
                  window.setTimeout(function () {
                      window.location.search ? (window.location.href = window.location.href.replace(window.location.search, "").replace(window.location.hash, "") + "#" + b.attr("href")) : (window.location.hash = b.attr("href"));
                  }, 150))
                : window.location.search
                ? (window.location.href = window.location.href.replace(window.location.search, "").replace(window.location.hash, "") + "#" + b.attr("href"))
                : (window.location.hash = b.attr("href")));
    }),
    $('nav a[target="_blank"]').on("click", function (a) {
        a.preventDefault();
        var b = $(a.currentTarget);
        window.open(b.attr("href"));
    }),
    $('nav a[target="_top"]').on("click", function (a) {
        a.preventDefault();
        var b = $(a.currentTarget);
        window.location = b.attr("href");
    }),
    $('nav a[href="#"]').on("click", function (a) {
        a.preventDefault();
    }),
    $(window).on("hashchange", function () {
        checkURL();
    })),
    $("body").on("click", function (a) {
        $('[rel="popover"], [data-rel="popover"]').each(function () {
            $(this).is(a.target) || 0 !== $(this).has(a.target).length || 0 !== $(".popover").has(a.target).length || $(this).popover("hide");
        });
    }),
    $(".modal").on("hidden.bs.modal", function () {
        $(this).removeData("bs.modal");
    });
